class BUTBackToTop extends BUTCustomComponent {
  constructor() {
    super();
    this.button = this.$('#back-to-top');
    if (!this.button) return;

    this.circle = this.$('.btn-back-top-top-circle');
    this.supportsScrollTimeline = CSS.supports('animation-timeline: scroll()');
    this.ticking = false;

    this.init();
    this.bindEventHandlers();
  }

  init() {
    this.toggleVisibility();
    if (!this.supportsScrollTimeline) this.updateBorderFilled();
  }

  bindEventHandlers() {
    window.addEventListener('scroll', () => this.onScroll());
    this.button.addEventListener('click', (e) => this.handleClick(e));
  }

  onScroll() {
    this.toggleVisibility();
    if (!this.supportsScrollTimeline && !this.ticking) {
      requestAnimationFrame(() => {
        this.updateBorderFilled();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  updateBorderFilled() {
    if (!this.circle) return;
    const doc = document.documentElement;
    const scrollable = doc.scrollHeight - doc.clientHeight;
    const progress = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 0;
    this.circle.style.setProperty('--border-filled', `${Math.min(100, Math.max(0, progress))}%`);
  }

  toggleVisibility() {
    this.button.classList.toggle('visible', window.scrollY > 400);
  }

  handleClick(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}

customElements.define('but-back-to-top', BUTBackToTop);